import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { SuppliesModel } from 'src/app/models/SuppliesModel';
import { SuppliesService } from 'src/app/services/SuppliesService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up



@Component({
  selector: 'app-codessearch',
  templateUrl: './codessearch.component.html',
  styleUrls: ['./codessearch.component.css']
})
export class CodessearchComponent implements OnInit {

  supCode = '';
  supName = '';
  supAddress = '';
  supGroup = '';
  supNotes = '';
  compCode = '1';
  suppliesList: SuppliesModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public suppliesService: SuppliesService,
              public supplies: SuppliesModel,
              public storage: LocalStorageService,
              public dialogRef: MatDialogRef<CodessearchComponent>,
              @Inject(MAT_DIALOG_DATA)
              public suppSelectedData: SuppliesModel) { }

  ngOnInit(): void {
    this.retriveSuppliesLookupTop();
  }

  retriveSuppliesLookup() {
    this.suppliesList = [];
    this.suppliesService.getSuppliesLookup(this.supCode, this.supName, this.storage.retrieve(('stgCompCode'))).subscribe((data: SuppliesModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.suppliesList[i] = data[i];
      }
      console.log(data);
    })
  }

  retriveSuppliesLookupTop() {
    this.suppliesList = [];
    this.suppliesService.getSuppliesLookupTop(this.storage.retrieve(('stgCompCode'))).subscribe((data: SuppliesModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.suppliesList[i] = data[i];
      }
      console.log(data);
    })
  }
  clickSelect(){
    this.storage.store('stgSearchCode', this.supCode);
  }

  SelectSupp(supp: SuppliesModel){
    this.suppSelectedData.supCode = supp.supCode
    this.suppSelectedData.supName = supp.supName
    this.suppSelectedData.supAddress= supp.supAddress
    this.suppSelectedData.supGroup= supp.supGroup
    this.suppSelectedData.supNotes= supp.supNotes
    console.log(" data.supGroup --:" +supp.supGroup);
    this.suppSelectedData.userID = supp.userID
    this.suppSelectedData.modifaiedDate = supp.modifaiedDate
    this.suppSelectedData.compCode = supp.compCode
    this.submitClicked.emit(this.suppSelectedData);
    this.dialogRef.close();
  }
}
